import { ACTIONS } from '../../constants/constants';

const partnerShipDetailsReducer = function (state = {}, action) {
  switch (action.type) {
    case ACTIONS.SET_USER_PARTNERSHIP_DETAILS:
      return action.data;
    default:
      return state;
  }
};

export default partnerShipDetailsReducer;
